/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { ContentPage } from '../models/models-content';

export enum ContentActionsTypes {
  InitContentPage = '[ContentPage] Init content page',
  SetContentPage = '[ContentPage] Set content page'
}

export class InitContentPage implements Action {
  readonly type = ContentActionsTypes.InitContentPage;
  constructor(public payload: any) {}
}

export class SetContentPage implements Action {
  readonly type = ContentActionsTypes.SetContentPage;
  constructor(public payload: { contentPage: ContentPage }) {}
}

export type ContentActions = InitContentPage | SetContentPage;
